module.exports = __webpack_public_path__ + "createstatic/media/categoryAddBtn.035f0a62.svg";